import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderDropDown from '../HeaderDropDown/';
import { FormattedMessage } from 'react-intl';
import { NEWTUBE_API_SERVER } from 'configs/url';
import './style.css';
import defaultPicture from '../../images/man-100x100.jpg';

export default class UserMenuItem extends Component {
  constructor() {
    super();
    this.handleLogout = this.handleLogout.bind(this);
    // this.handleCompanySelect = this.handleCompanySelect.bind(this);
  }

  // handleCompanySelect(event) {
  //   const { onCompanySelect } = this.props;
  //   if (typeof onCompanySelect === 'function') {
  //     onCompanySelect(event);
  //   }
  // }

  handleLogout() {
    const { onLogout } = this.props;
    if (onLogout && typeof onLogout === 'function') {
      onLogout();
    }
  }

  render() {
    const { userName } = this.props;
    const dropdownToggle = (
      <div className="user-menu">
        <img className="user-menu__image"
          src={`${NEWTUBE_API_SERVER}users/personalPicture`}
          onError={(e) => e.target.setAttribute('src', defaultPicture)}
        />
        <span className="user-menu__welcome">
          <FormattedMessage
            id="SH_Welcome"
            defaultMessage="歡迎, {0}"
            values={{
              0: userName,
            }}
          />
        </span>
      </div>
    );

    return (
      <HeaderDropDown
        dropdownToggleClassName="user-menu__dropdown-toggle"
        title={dropdownToggle}
        {...this.props}
      >
        <li className="user-menu__item">
          <a href="/tube/accountsetting" id="languageSetting" className=" ta__confirmation"
            onClick={this.props.onLinkClick}
          >
            <span className="user-menu__item-icon">
              <i className="fa fa-lock"></i>
            </span>
            <FormattedMessage
              id="SH_ChangePassword"
              defaultMessage="修改密碼"
            />
          </a>
        </li>
        {/* foundation 1.7 9.5 待需求再開時加回 */}
        {/* <li className="user-menu__item">
          <a onClick={this.handleCompanySelect}>
            <span className="user-menu__item-icon">
              <i className="fa fa-exchange" aria-hidden="true" />
            </span>
            <FormattedMessage
              id="SELECTCOMPANY"
              defaultMessage="多公司切換"
            />
          </a>
        </li> */}
        <li className="divider"></li>
        <li className="user-menu__item">
          <a
            className="ta__confirmation"
            href="#"
            onClick={this.handleLogout}
            id="languageLogout"
          >
            <span className="user-menu__item-icon">
              <i className="fa fa-power-off"></i>
            </span>
            <FormattedMessage
              id="SH_Logout"
              defaultMessage="登出"
            />
          </a>
        </li>
      </HeaderDropDown>
    );
  }
}

UserMenuItem.propTypes = {
  userName: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  // onCompanySelect: PropTypes.func.isRequired,
  onLinkClick: PropTypes.func,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Header/components/UserMenuItem/index.js
 **/